
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/upplysinganumerid",
      function () {
        return require("private-next-pages/um/thjonusta/upplysinganumerid.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/upplysinganumerid"])
      });
    }
  